module.exports = __webpack_public_path__ + "static/media/Artboard4.7444cf55.png";